import React from 'react';
import { motion } from 'framer-motion';

export default function DocumentsLoading({ viewMode = 'grid' }) {
  if (viewMode === 'grid') {
    return (
      <div className="flex gap-6 overflow-x-auto pb-4 md:pb-6">
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
            className="flex min-w-[280px] flex-1 shrink-0 flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-md sm:min-w-[300px] md:min-w-[320px]"
          >
            <div className="h-40 animate-pulse bg-gradient-to-br from-gray-200 to-gray-100 sm:h-44" />
            <div className="flex flex-1 flex-col p-4">
              <div className="h-4 w-3/4 animate-pulse rounded-lg bg-gray-200" />
              <div className="mt-3 flex gap-2">
                <div className="h-5 w-16 animate-pulse rounded-full bg-gray-100" />
                <div className="h-5 w-12 animate-pulse rounded-full bg-gray-100" />
              </div>
              <div className="mt-3 h-3 w-1/2 animate-pulse rounded bg-gray-100" />
              <div className="mt-4 flex gap-2 border-t border-gray-100 pt-3">
                <div className="h-9 w-9 animate-pulse rounded-lg bg-gray-200" />
                <div className="h-9 w-9 animate-pulse rounded-lg bg-gray-200" />
                <div className="h-9 w-9 animate-pulse rounded-lg bg-gray-200" />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {[...Array(6)].map((_, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.05 }}
          className="flex items-center gap-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5"
        >
          <div className="h-12 w-12 animate-pulse rounded-xl bg-gradient-to-br from-gray-200 to-gray-300 sm:h-14 sm:w-14" />
          <div className="min-w-0 flex-1 space-y-3">
            <div className="h-4 w-3/4 animate-pulse rounded-lg bg-gray-200" />
            <div className="flex gap-2">
              <div className="h-5 w-16 animate-pulse rounded-full bg-gray-100" />
              <div className="h-5 w-20 animate-pulse rounded-full bg-gray-100" />
              <div className="h-5 w-24 animate-pulse rounded-full bg-gray-100" />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="h-9 w-9 animate-pulse rounded-lg bg-gray-200" />
            <div className="h-9 w-9 animate-pulse rounded-lg bg-gray-200" />
            <div className="h-9 w-9 animate-pulse rounded-lg bg-gray-200" />
          </div>
        </motion.div>
      ))}
    </div>
  );
}
